import db from '../db';

const executions = db.table('executions');


  async function getAllExecutions() {
    try {
      let execs = await executions.toArray();
      return execs;
    } catch (error) {
      throw error
    }
  };

  async function getOneExecution(id) {
    try {
      return await executions.get({id: Number(id)});
    } catch (error) {
      throw error
    }
  }

  async function createExecution(execution) {
    let exec = {
      ...execution,
      status: 'open'
    }
    try {
      await executions.add({...exec});
    } catch (error) {
      throw error
    }
  };

  async function updateOneExecution(execution) {
    try {
      await executions.put({...execution});
      return execution;
    } catch (error) {
      throw error
    }
  };

  // async function delete(execution) {
  //   try {
  //     await executions.delete(execution.id);
  //   } catch (error) {
  //     throw error
  //   }
  // };

export default {
  getAllExecutions,
  getOneExecution,
  createExecution,
  updateOneExecution
};